import { NavBar } from "@/components/NavBar";
import { BlogDetail } from "@/components/blog/BlogDetail";
import { useTranslation } from "react-i18next";

const BlogDetailPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <div className="flex-1">
        <BlogDetail />
      </div>
    </div>
  );
};

export default BlogDetailPage;
